<template>
  <div>
    <SPreloader />
    <div>
      <SLandingTopBar />
      <SSubHeader pageName="Password recovery" />
      <div class="header-spacer--standard"></div>
      <md-content class="page-content">
        <md-content class="md-elevation-1 mb-4 center-content">
          <div class="form-content">
            <h5>
              Please provide the following information (those marked with * are
              required)
            </h5>
            <form
              class="content form"
              @submit.prevent="sendChange"
              autocomplete="off"
            >
              <div class="row">
                <div class="col col-12 col-xl-12 col-lg-12 col-md-12 col-sm-12">
                  <div
                    data-toggle="tooltip"
                    data-placement="bottom"
                    data-html="true"
                    title="<div class='text-left'><b>Password must have</b><br>
              - at least 1 number<br>
              - at least 1 lowercase letter<br>
              - at least 1 uppercase letter<br>
              - at least 8 characters
              </div>"
                  >
                    <VuePassword
                      v-model="new_password"
                      :strength="passwordScore"
                      disableToggle
                    >
                      <template v-slot:password-input>
                        <div
                          class="label-floating col-12 pl-0 pr-0 mb-0 registration-input"
                          :class="[
                            {
                              'has-value': new_password !== '',
                              'has-error': hasError,
                            },
                          ]"
                        >
                          <md-field class="form-input">
                            <label>New password</label>
                            <md-input
                              v-model="new_password"
                              @input="updateStrength(new_password)"
                              type="password"
                              class="form-control"
                              :required="true"
                              name="new-password"
                              autocomplete="new-password"
                            >
                            </md-input>
                          </md-field>
                        </div>
                      </template>
                    </VuePassword>
                    <span class="pass-strength">{{ password_strength }}</span>
                  </div>
                  <SInput
                    label="Password confirmation"
                    type="password"
                    ref="passwordConfirmation"
                    fieldClass="form-input"
                    :required="true"
                    name="new-password"
                    autocomplete="new-password"
                    class="mt-4"
                    :class="[
                      {
                        'has-value': confirmPassword !== '',
                        'has-error': hasError,
                      },
                    ]"
                    v-model="confirmPassword"
                    @input="clearError"
                  />
                  <span
                    v-if="text && !sucessUpdate"
                    class="text-info mb-4"
                    :class="[{ 'text-error': hasError }]"
                    >{{ text }}</span
                  >
                  <span v-if="sucessUpdate" class="text-info mb-4">
                    Password successfully updated
                    <router-link class="login-link ml-1" to="/login"
                      >Log in</router-link
                    >
                  </span>
                  <div
                    class="actions md-layout md-alignment-center-space-between"
                  >
                    <SButtonMaterial
                      buttonType="button"
                      color="primary"
                      textColor="white"
                      materialClass="dense"
                      text="Submit"
                      @button="sendChange"
                      :disabled="sucessUpdate"
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>
          <LoadingSpinner position="relative" v-if="state === 'PROCESSING'" />
        </md-content>
      </md-content>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import SLandingTopBar from "@/material-components/organisms/SLandingTopBar.vue";
import SPreloader from "@/components/organisms/SPreloader.vue";
import SInput from "@/material-components/atoms/SInput.vue";
import SButtonMaterial from "@/material-components/atoms/SButtonMaterial.vue";
import LoadingSpinner from "@/material-components/atoms/LoadingSpinner.vue";
import VuePassword from "vue-password";
import zxcvbn from "zxcvbn";
import Auth from "@/modules/Auth";
import Global from "@/constants/Global";
import SSubHeader from "@/material-components/organisms/SSubHeader.vue";
export default {
  name: "PasswordResetMaterial",
  data() {
    return {
      new_password: "",
      passwordScore: 0,
      notify_password_change: false,
      token: "",
      text: "",
      state: "WAITING_INPUT",
      confirmPassword: "",
      strengthMsgs: [
        "Very Weak Password",
        "Weak Password",
        "Medium Password",
        "Strong Password",
        "Very Strong Password",
      ],
      hasError: false,
      sucessUpdate: false,
    };
  },
  components: {
    SLandingTopBar,
    SPreloader,
    VuePassword,
    SInput,
    SButtonMaterial,
    LoadingSpinner,
    SSubHeader,
  },
  methods: {
    ...mapActions(["changePassword", "endSession"]),
    updateStrength(password) {
      this.passwordScore = zxcvbn(password).score;
      this.clearError();
    },
    clearError() {
      this.hasError = false;
      if (this.text.length > 0) {
        this.text = "";
      }
    },
    checkPassword() {
      if (!this.new_password) {
        this.text = "Password cannot be empty";
        this.hasError = true;
      } else if (! (/(?=.*[A-Z])/).test(this.new_password)) {
        this.text = "Password must have at least 1 uppercase letter";
        this.hasError = true;
      } else if (! (/(?=.*\d)/).test(this.new_password)) {
        this.text = "Password must have at least 1 number";
        this.hasError = true;
      } else if (! (/(?=.{8,})/).test(this.new_password)) {
        this.text = "Password must have at least 8 charcters";
        this.hasError = true;
      } else if (! (/(?=.*[a-z])/).test(this.new_password)) {
        this.text = "Password must have at least 1 lowercase letter";
        this.hasError = true;
      } else if (this.passwordScore < 1) {
        this.text = "Your password is weak";
        this.hasError = true;
      } else if (this.confirmPassword !== this.new_password) {
        this.text = "Both fields must have the same password";
        this.hasError = true;
      } else {
        this.text = "";
        this.hasError = false;
      }
    },
    sendChange() {
      this.state = "PROCESSING";
      this.clearError();
      this.checkPassword();
      if (!this.hasError) {
        let update = {
          password: this.new_password,
        };
        fetch(Global.getServerDomain() + "/changePassword", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            auth_key: this.token,
          },
          body: JSON.stringify(update),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.error) {
              this.text = response.error;
              this.hasError = true;
            } else {
              this.text = response.result;
            }
            this.sucessUpdate = true;
          });
      }
      this.state = "FINISH";
    },
  },
  computed: {
    password_strength() {
      return this.strengthMsgs[zxcvbn(this.new_password).score];
    },
  },
  beforeCreate() {
    Auth.deauthenticateUser();
    localStorage.removeItem("user_id");
    console.log("passei5");
  },
  mounted() {
    this.endSession();
    sessionStorage.clear();
    this.token = this.$route.query.token;
    $("[data-toggle='tooltip']").tooltip();
  },
};
</script>

<style lang="scss" scoped>
.page-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: $light !important;
  letter-spacing: 1.25px;
}
.center-content {
  max-width: 1250px;
  width: 80%;
  height: 90%;
  border: 1px solid rgba(128, 128, 128, 0.3);
  box-sizing: border-box;
  border-radius: 5px;
  margin-top: 2rem;
}
.form-input {
  border: 1px rgba(0, 0, 0, 0.12) solid;
  border-radius: 3px;
}
.md-field:after {
  height: 0;
}
.md-field:before {
  height: 0px;
}
input {
  margin-left: 11px;
}
.md-input {
  padding: 7px 0px 10px 0px;
  width: 100%;
  height: 100%;
}
label {
  font-size: 14px;
  margin-left: 11px;
  top: 15px;
}
.registration-input {
  margin-top: 0.8rem !important;
}
.md-field {
  margin: 0.1875rem 0 -0.05rem;
}
.md-list-item-text p {
  white-space: normal;
  padding-bottom: 0;
}
</style>

<style lang="scss" scoped>
.md-focused {
  border-color: $primary;
}
.md-field.md-theme-swampum-primary.md-focused label {
  color: $primary;
}
.pass-strength {
  color: $dark !important;
}
.form-content {
  padding: 1rem;
}
.content {
  padding-left: 12rem;
  padding-right: 12rem;
}
.actions {
  justify-content: center;
}
.text-info {
  display: flex;
  justify-content: center;
}
.text-error,
.text-info {
  font-weight: bold;
}
.text-error {
  color: $danger;
}
.login-link {
  color: $primary !important;
}
@media screen and (max-width: 768px) {
  .content {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}
</style>

<style lang="scss">
.has-value .md-field.md-theme-swampum-primary label {
  color: $primary !important;
}
.has-value .form-input {
  border: 1px solid $primary;
}
.has-error .md-field.md-theme-swampum-primary label {
  color: $danger !important;
}
.has-error .form-input {
  border: 1px solid $danger !important;
}
</style>
